import { type PropsWithChildren, forwardRef } from "react";
import { type LinkProps, Link as _Link } from "react-router";

export const Link = forwardRef<
  HTMLAnchorElement,
  PropsWithChildren<Omit<LinkProps, "to"> & { href: string }>
>(function Link(props, ref) {
  return <_Link {...props} to={props.href} ref={ref} />;
});
